import { FetcherError } from '~/lib/app/fetcher'

// Some utilities to help with debugging and testing
export class AppDebug {
  async testFetcherError(jsonBody: any = { error: 'test' }) {
    throw new FetcherError(new Response(null, { status: 500 }), jsonBody)
  }
}
